[game]
tickrate = 64
tickrate_ms = 16
min_move_ticks = 10 		# set the minimum move tick rate
stress_duration_ticks = 192 	# 64 * 3 
stuck_duration_ticks = 192 	# 64 * 3 

[network]
sync_rate_ticks = 5

[client]
min_width = 320
min_height = 480 		# 320 * 1.5
move_duration_ticks = 16	# tickrate / 4


[server]
port = 10067
client_lookahead_ms = 62	# TICK_RATE_MS * 4 packet should arrive 4 ticks early

